import {
  Edit,
  Check,
  ChevronsDown,
  ChevronsUp,
  ArrowRight
} from 'lucide-react';

/**
 * AI options for text transformations
 * Each option has a label, key for API calls, and icon
 */
export const AI_OPTIONS = [
  { label: 'Mejora escritura', key: 'improve', Icon: Edit },
  { label: 'Corrige gramática', key: 'fix_grammar', Icon: Check },
  { label: 'Hacer más corto', key: 'shorten', Icon: ChevronsDown },
  { label: 'Hacer más largo', key: 'lengthen', Icon: ChevronsUp },
  { label: 'Continúa escritura', key: 'continue', Icon: ArrowRight }
];

/**
 * API endpoint for AI competitions
 */
export const AI_API_ENDPOINT = '/ai_competitions';

/**
 * Action types for API calls
 */
export const ACTION_TYPES = {
  ASK: 'ask',
  IMPROVE: 'improve',
  FIX_GRAMMAR: 'fix_grammar',
  SHORTEN: 'shorten',
  LENGTHEN: 'lengthen',
  CONTINUE: 'continue'
};
